import styled from 'styled-components';
import { getSizeBy } from '../../../../../src/styled/utils';
import { IconButton } from '../../../icon-button';
import AccordionIcon from '../../../icon/special/accordion-styled';
export const ExpandToggleButton = styled(IconButton) `
  display: ${({ disabled }) => disabled && 'none'};
  padding: ${getSizeBy(2)};
`;
export const ExpandToggle = styled(AccordionIcon) `
  width: ${getSizeBy(4)};
`;
